import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function JoinSignup() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ name: "", email: "", mobile: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get(`/join/${token}`).then(({ data }) => setInfo(data))
      .catch((e) => setError(apiError(e.response?.data?.detail)));
  }, [token]);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/join", { token, ...form });
      toast.success("Account created. Verify your email.");
      navigate("/verify-email", { state: { email: data.email, fromJoin: true } });
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (error) return <AuthShell title="Join"><p className="text-center text-sm text-rose-600" data-testid="join-error">{error}</p></AuthShell>;
  if (!info) return <AuthShell title="Join"><p className="text-center text-sm text-slate-500">Loading…</p></AuthShell>;

  return (
    <AuthShell title={`Join ${info.org_name}`} subtitle="Create your employee account">
      <form onSubmit={submit} className="space-y-4" data-testid="join-form">
        <div>
          <Label htmlFor="jn">Full name</Label>
          <Input id="jn" required value={form.name} onChange={upd("name")} className="mt-1.5" data-testid="join-name" />
        </div>
        <div>
          <Label htmlFor="je">Email</Label>
          <Input id="je" type="email" required value={form.email} onChange={upd("email")} className="mt-1.5" data-testid="join-email" />
        </div>
        <div>
          <Label htmlFor="jm">Mobile</Label>
          <Input id="jm" value={form.mobile} onChange={upd("mobile")} className="mt-1.5" data-testid="join-mobile" />
        </div>
        <div>
          <Label htmlFor="jp">Create password</Label>
          <Input id="jp" type="password" required minLength={8} value={form.password} onChange={upd("password")}
            className="mt-1.5" placeholder="Min. 8 characters" data-testid="join-password" />
        </div>
        <Button type="submit" className="w-full" disabled={loading} data-testid="join-submit">
          {loading ? "Creating…" : "Create account"}
        </Button>
      </form>
    </AuthShell>
  );
}
